import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { NewsletterForm } from '../../../../vtex-apps/store-newsletter/NewsletterForm/default';
import { NewsletterInputEmail } from '../../../../vtex-apps/store-newsletter/NewsletterInputEmail/default';
import { NewsletterInputName } from '../../../../vtex-apps/store-newsletter/NewsletterInputName/default';
import { NewsletterSubmit } from '../../../../vtex-apps/store-newsletter/NewsletterSubmit/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { NewsletterCheckboxConfirmation } from '../../../../vtex-apps/store-newsletter/NewsletterCheckboxConfirmation/default';

export default function Newsletter() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'Newsletter',
		props: VisibilityLayout({ mzTitle: 'MZ | Newsletter (On/Off)' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'footer-newsletter-1__row',
					colSizing: 'equal',
					preserveLayoutOnMobile: true,
					fullWidth: true,
					mzTitle: 'MZ | Newsletter',
				},
				[
					FlexLayoutCol({ blockClass: 'footer-col__newsletter-background-1' }, [
						StoreImageList(
							{
								preload: true,
								props: { blockClass: 'news-1__image' },
								images: [
									{
										image:
											'https://hefesto-upload-images.s3.amazonaws.com/1683060309594-newsletter---5c4e49de321ff13a4ede0b8554783cd6.png',
										mobileImage:
											'https://hefesto-upload-images.s3.amazonaws.com/1683060309594-newsletter---5c4e49de321ff13a4ede0b8554783cd6.png',
										description: 'Imagem',
									},
								],
							},
							[
								ListContextRenderer({
									listElement: 'div',
									itemElement: 'div',
									blockClass: 'news-1__flex-row',
								}),
							],
						),
					]),
					NewsletterForm({ blockClass: 'footer__newsletter-1' }, [
						FlexLayoutRow({ blockClass: 'footer-row__newsletter-1' }, [
							FlexLayoutCol({ blockClass: 'footer-col__newsletter-1' }, [
								RichText({
									text: 'Receba descontos e novidades diretamente no seu e-mail',
									blockClass: ['footer-rich-text__newsletter-1'],
								}),
								FlexLayoutRow({ blockClass: ['footer-inner-row__newsletter-1'], colSizing: 'auto' }, [
									NewsletterInputName({
										blockClass: 'newsletter__input-name-1',
										inputLabel: 'Informe seu nome',
									}),
									NewsletterInputEmail({
										blockClass: 'newsletter__input-email-1',
										inputLabel: 'Informe seu email',
									}),
									NewsletterSubmit({
										blockClass: 'newsletter__submit-button-1',
										submitButtonLabel: 'Cadastrar',
									}),
								]),
								FlexLayoutRow(
									{
										blockClass: ['footer-inner-row__newsletter-last-1'],
										colSizing: 'auto',
									},
									[
										NewsletterCheckboxConfirmation({
											blockClass: 'footer-1',
											checkboxLabel: ' ',
										}),
										RichText({
											mzTitle: 'MZ | Newsletter - políticas',
											text: 'Ao se cadastrar você irá concordar com a nossa [Política de Privacidade](/politica-de-privacidade) e poderá alterar ou cancelar a newsletter a qualquer momento que desejar. Aqui você economiza nas suas compras e não recebe spam.',
											blockClass: ['newsletter__help-message-checkbox-1'],
										}),
									],
								),
								NewsletterSubmit({
									blockClass: 'newsletter__submit-button-mobile-1',
									submitButtonLabel: 'Cadastrar',
								}),
							]),
						]),
					]),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{
				from: '--transparent',
				to: '--newsletter-1-background-color',
				name: 'Background Color',
			},
			{ from: '--white', to: '--newsletter-1-text-color', name: 'Text Color' },
			{ from: '--white', to: '--newsletter-1-input-border-color', name: 'Input Border Color' },
			{ from: '--transparent', to: '--newsletter-1-input-hover-color', name: 'Input Hover Color' },
			{ from: '--cta-color-pure', to: '--newsletter-1-cta-pure', name: 'CTA Color' },
			{ from: '--cta-color-focus', to: '--newsletter-1-cta-focus', name: 'CTA Hover Color' },
			{ from: '--cta-color-hover', to: '--newsletter-1-cta-hover', name: 'CTA Focus Color' },
			{ from: '--white', to: '--newsletter-1-cta-text-color', name: 'CTA Text Color' },
			{ from: '--white', to: '--newsletter-1-politicas-link', name: 'Políticas Link Color' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--newsletter-1-border-radius', name: 'Border Radius' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--newsletter-1-header-desktop-size', name: 'Header Desktop Size' },
			{ from: '--font-size-xl', to: '--newsletter-1-header-mobile-size', name: 'Header Mobile Size' },
			{ from: '--font-size-sm', to: '--newsletter-1-input-size', name: 'Input Font Size' },
			{ from: '--font-size-sm', to: '--newsletter-1-cta-size', name: 'CTA Font Size' },
			{ from: '--font-size-xs', to: '--newsletter-1-info-size', name: 'Infotext Font Size' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--newsletter-1-header-font', name: 'Headline Font Family' },
			{ from: '--main-font', to: '--newsletter-1-body-font', name: 'Body Font Family' },
			{ from: '--main-font', to: '--newsletter-1-cta-font', name: 'CTA Font Family' },
		],
	},
];
